import React from 'react';
export function HeroSection() {
  return <section className="relative min-h-[70vh] flex items-center justify-center overflow-hidden bg-brand-darker" data-id="element-163">
      {/* Simplified background — single gradient, no radial (reduces paint) */}
      <div className="absolute inset-0 z-0 bg-gradient-to-b from-brand-darker via-brand-darker/90 to-brand-darker" aria-hidden="true" data-id="element-164" />

      <div className="relative z-10 container mx-auto px-4 py-14 flex flex-col items-center text-center max-w-5xl" data-id="element-165">
        {/* Title — NO animation, renders instantly for fastest FCP */}
        <h1 className="text-5xl md:text-7xl lg:text-8xl font-bold text-white mb-8 leading-[1.1] text-glow-red" data-id="element-166">
          ¿Cuántas veces más vas a quedar tirado en la calle esperando que
          alguien venga a rescatarte?
        </h1>

        {/* LCP Image — NO wrapper animation, NO transform, immediate paint */}
        <div className="w-full flex justify-center" style={{
        maxWidth: '56rem',
        aspectRatio: '1376/768'
      }} data-id="element-167">
          <img src="https://cdn.magicpatterns.com/uploads/2oMb5AVTctNw69Kf1Y1zf5/acostsdo.png" alt="Master Pack Reparación Express - Sistema completo de diagnóstico y reparación para monopatines eléctricos. 5 Tomos y 2 Bonos incluidos." className="w-full max-w-4xl rounded-2xl shadow-2xl shadow-black/50 mb-10" width={1376} height={768} fetchPriority="high" decoding="async" loading="eager" style={{
          aspectRatio: '1376/768',
          contentVisibility: 'auto'
        }} data-id="element-168" />
        </div>

        <div className="max-w-3xl" data-id="element-169">
          <p className="text-xl md:text-2xl text-zinc-300 mb-6 font-medium leading-relaxed" data-id="element-170">
            Hay usuarios que cuando el monopatín falla en la calle saben
            exactamente qué hacer en 5 minutos.
          </p>
          <p className="text-xl md:text-2xl text-zinc-400 leading-relaxed" data-id="element-171">
            Y hay usuarios que llaman un remis y llegan tarde al trabajo. La
            diferencia no es el conocimiento técnico.{' '}
            <span className="text-brand-red font-bold" data-id="element-172">
              Es si tienen un sistema o no.
            </span>
          </p>
        </div>

        <div className="mt-6" aria-hidden="true" data-id="element-173">
          <div className="w-1 h-16 bg-gradient-to-b from-brand-red to-transparent mx-auto rounded-full opacity-50" data-id="element-174"></div>
        </div>
      </div>
    </section>;
}